import styled from 'styled-components'
import { DASHBOARD, FEATURED } from 'constants/appConstants'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${props =>
    props.contentType === DASHBOARD || props.contentType === FEATURED
      ? 'repeat(3, minmax(0, 1fr))'
      : 'repeat(4, minmax(0, 1fr))'};
  grid-gap: 12px;
`
